import { HttpParams } from '@angular/common/http';

export function createHttpParams<T extends object>(obj: T): HttpParams {
  let params = new HttpParams();

  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined && value !== null) {
      params = params.set(key, String(value));
    }
  }

  return params;
}
